<template>
  <div>
    <v-row align="center" no-gutters>
      <span class="mr-5">{{ attributeData.displayName }}</span>
      <v-switch
        inset
        dense
        :disabled="isLoading"
        :input-value="value"
        :value="value"
        :error-messages="errorMessage"
        @change="$emit('input', $event === null ? false : $event)"
      />
    </v-row>
  </div>
</template>

<script>
export default {
  name: 'attribute-field-BOOLEAN',
  props: {
    attributeData: {
      type: Object,
      default: () => {}
    },
    errorMessage: {
      type: String,
      default: null
    },
    value: {
      type: Boolean,
      default: false
    },
    isLoading: {
      type: Boolean,
      default: false
    }
  }
}
</script>
